<template>
  <b-icon v-if="data.item.codigoColor != null " icon="circle-fill" aria-hidden="true" font-scale="1.5" :style="{color: data.item.codigoColor}"></b-icon>

</template>

<script>
export default {
  name: "SemaforoSLA",
  props: {
    data: Object,
    resource: Object,
  },
}
</script>

<style scoped>

</style>
